export default "__VITE_ASSET__MAY49GGc__"